<template>
	<button
		class="global-language-select"
		:class="{ 'global-language-select--big': big, 'global-language-select--compact': compact }"
		aria-label="Wybierz język">
		<ClientOnly>
			<template #fallback>
				<div class="global-language-select__activator">
					<div class="global-language-select__country">
						<div class="global-language-select__country-flag-wrapper">
							<GlobalIcon
								class="global-language-select__country-icon"
								:name="getCountryFlagIconName(locale)"
								prefix="country"
								:height="compact ? 16 : 24"
								:width="compact ? 16 : 24" />
						</div>
						<div v-if="big" class="global-language-select__country-text">{{ locale?.toUpperCase() }}</div>
					</div>
					<GlobalIcon name="arrow-down" :height="compact ? 12 : 16" class="global-language-select__select-icon" />
				</div>
			</template>
			<v-menu attach class="global-language-select__menu" :class="{ 'global-language-select__menu--big': big }" scroll-strategy="close">
				<template #activator="{ props }">
					<div class="global-language-select__activator" role="button" aria-label="Przełącz język" v-bind="props">
						<div class="global-language-select__country">
							<div class="global-language-select__country-flag-wrapper">
								<!-- <Icon class="global-language-select__country-icon" :name="getCountryFlagIconName(locale)" /> -->
								<GlobalIcon
									class="global-language-select__country-icon"
									:name="getCountryFlagIconName(locale)"
									prefix="country"
									:height="compact ? 16 : 24"
									:width="compact ? 16 : 24" />
							</div>
							<div v-if="big" class="global-language-select__country-text">{{ fullName(locale?.toUpperCase()) }}</div>
						</div>
						<GlobalIcon name="arrow-down" :height="compact ? 12 : 16" class="global-language-select__select-icon" />
					</div>
				</template>
				<LazyGlobalLanguageSelectList :items="menuItems" :big @select="changeLang" />
			</v-menu>
		</ClientOnly>
	</button>
</template>

<script setup lang="ts">
const { locale, locales } = useI18n()
const i18nService = usei18nService()
const locationRedirectStore = useLocationRedirectStore()
const route = useRoute()
const $t = useI18n().t

defineProps<{
	big?: boolean
	compact?: boolean
}>()

const fullName = (c: string) => {
	const country = CountryIsoNamesLanguagePack.find((country) => country.languageCode.toLowerCase() === c.toLowerCase())
	return country ? $t(`components.language_select.language.${country.language?.toLowerCase()}`) : ''
}

const menuItems = computed(() =>
	locales.value.map((item) => ({ code: item.code, name: item.name ?? item.code, fullName: fullName(item.name ?? item.code) })),
)

const changeLang = (code: string) => {
	if (route.name?.toString().includes('car-rental-urlSlug') || route.name?.toString().includes('blog-newsTitle')) {
		locationRedirectStore.setRedirectLang(code)
		return
	}
	i18nService.changeLang(code)
}
</script>

<style lang="scss" src="./LanguageSelect.scss"></style>
